import { render, staticRenderFns } from "./SolicitudVentaModal.vue?vue&type=template&id=87dcf4f0"
import script from "./SolicitudVentaModal.vue?vue&type=script&lang=js"
export * from "./SolicitudVentaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports